import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';
import {
    GetLostPackageShipmentsApiResponse,
    GetLostPackageShipmentsRequest,
} from '../../../types/models/lostCargo/lostCargo.types';

const PrintOrCancel = (data: any): Promise<any> =>
    request({
        url: ApiURL.Command.PrintOrCancel,
        method: RequestType.PUT,
        data,
    });

const GetLostCargoList = (data: GetLostPackageShipmentsRequest): Promise<GetLostPackageShipmentsApiResponse> =>
    request({
        url: ApiURL.Command.GetLostCargoList,
        method: RequestType.POST,
        data,
    });

const LostCargoCommand = {
    PrintOrCancel,
    GetLostCargoList,
};

export default LostCargoCommand;
